module.exports = __webpack_public_path__ + "img/Rust-2-mobile.b9970ff7.png";